const stations = {
  300: {
    id: '300',
    labels: {heb: 'פאתי מודיעין', eng: 'Pa\'ate Modi\'in', rus: 'Патей Модиин', arb: 'بأتي موديعين'}
  },
  400: {
    id: '400',
    labels: {heb: 'מודיעין מרכז', eng: 'Modi\'in-Center', rus: 'Модиин центр ', arb: 'موديعين - المركز'}
  },
  680: {
    id: '680',
    labels: {
      heb: 'ירושלים - יצחק נבון',
      eng: 'Jerusalem - Yitzhak Navon',
      rus: 'Иерусалим - Ицхак Навон',
      arb: 'أورشليم – يتسحاق ناڤون'
    }
  },
  700: {
    id: '700',
    labels: {heb: 'קריית חיים', eng: 'Kiryat Hayim', rus: 'Кирьят-Хаим', arb: 'كريات حاييم'}
  },
  1220: {
    id: '1220',
    labels: {
      heb: 'מרכזית המפרץ (לב המפרץ)',
      eng: 'HaMifrats Central Station',
      rus: 'Центральная станция Ха-Мифрац',
      arb: 'همفراتس المركزية'
    }
  },
  1240: {
    id: '1240',
    labels: {
      heb: 'יקנעם - כפר יהושע',
      eng: 'Yokne\'am-Kfar Yehoshu\'a',
      rus: 'Йокнеам – Кфар-Иегошуа',
      arb: 'يوكنعام – كفار يهوشوع'
    }
  },
  1250: {
    id: '1250',
    labels: {
      heb: 'מגדל העמק - כפר ברוך',
      eng: 'Migdal Ha\'emek-Kfar Barukh',
      rus: 'Мигдаль-Ха-Эмек – Кфар Барух',
      arb: 'مجدال هعيمك – كفار باروخ'
    }
  },
  1260: {
    id: '1260',
    labels: {heb: 'עפולה ר.איתן', eng: 'Afula R.Eitan', rus: 'Афула Р. Эйтан', arb: 'العفولة  ر. ايتان'}
  },
  1280: {id: '1280', labels: {heb: 'בית שאן', eng: 'Beit She\'an', rus: 'Бейт Шеан', arb: 'بيت شآن'}},
  1300: {
    id: '1300',
    labels: {heb: 'חוצות המפרץ', eng: 'Hutsot HaMifrats', rus: 'Хоцот ха-Мифрац ', arb: 'حوتسوت همفراتس'}
  },
  1400: {
    id: '1400',
    labels: {heb: 'קריית מוצקין', eng: 'Kiryat Motzkin', rus: 'Кирьят-Моцкин', arb: 'كريات موتسكين'}
  },
  1500: {id: '1500', labels: {heb: 'עכו', eng: 'Ako', rus: 'Акко ', arb: 'عكا'}},
  1600: {id: '1600', labels: {heb: 'נהריה', eng: 'Nahariya', rus: 'Нагария', arb: 'نهاريا'}},
  1820: {id: '1820', labels: {heb: 'אחיהוד', eng: 'Ahihud', rus: 'Ахихуд', arb: 'احيهود'}},
  1840: {id: '1840', labels: {heb: 'כרמיאל', eng: 'Karmiel', rus: 'Кармиэль', arb: 'كرميئيل'}},
  2100: {
    id: '2100',
    labels: {
      heb: 'חיפה- מרכז השמונה',
      eng: 'Haifa Center-HaShmona',
      rus: 'Хайфа - Мерказ - Центральная',
      arb: 'حيفا المركز - هشمونا'
    }
  },
  2200: {
    id: '2200',
    labels: {heb: 'חיפה - בת גלים', eng: 'Haifa-Bat Galim', rus: 'Хайфа - Бат-Галим', arb: 'حيفا - بات چاليم'}
  },
  2300: {
    id: '2300',
    labels: {
      heb: 'חיפה - חוף הכרמל (ש\' רזיאל)',
      eng: 'Haifa-Hof HaKarmel (Razi`el)',
      rus: 'Хайфа Хоф ха-Кармель',
      arb: 'حيفا - شاطئ الكرمل'
    }
  },
  2500: {id: '2500', labels: {heb: 'עתלית', eng: 'Atlit', rus: 'Атлит', arb: 'عتليت'}},
  2800: {id: '2800', labels: {heb: 'בנימינה', eng: 'Binyamina', rus: 'Биньямина', arb: 'بنيامينا'}},
  2820: {
    id: '2820',
    labels: {
      heb: 'קיסריה - פרדס חנה',
      eng: 'Caesarea-Pardes Hana',
      rus: 'Кейсария - Пардес-Хана',
      arb: 'قيساريا - بارديس حنا'
    }
  },
  2940: {
    id: '2940',
    labels: {heb: 'רעננה מערב', eng: 'Ra\'anana West', rus: 'Раанана-Вест', arb: 'رعنانا – غرب'}
  },
  2960: {
    id: '2960',
    labels: {heb: 'רעננה דרום', eng: 'Ra\'anana South', rus: 'Раанана Южный', arb: 'رعنانا الجنوبية'}
  },
  3100: {
    id: '3100',
    labels: {heb: 'חדרה - מערב', eng: 'Hadera-West', rus: 'Хадера - Маарав', arb: 'الخضيرة - غرب  '}
  },
  3300: {id: '3300', labels: {heb: 'נתניה', eng: 'Netanya', rus: 'Нетания', arb: 'نتانيا'}},
  3310: {
    id: '3310',
    labels: {heb: 'נתניה - ספיר', eng: 'Netanya-Sapir', rus: 'Нетания – Сапир', arb: 'نتانيا - سبير'}
  },
  3400: {
    id: '3400',
    labels: {heb: 'בית יהושע', eng: 'Bet Yehoshu\'a', rus: 'Бейт-Иегошуа ', arb: 'بيت يهوشوع'}
  },
  3500: {id: '3500', labels: {heb: 'הרצליה', eng: 'Hertsliya', rus: 'Герцлия', arb: 'هرتسليا'}},
  3600: {
    id: '3600',
    labels: {
      heb: 'תל אביב - אוניברסיטה',
      eng: 'Tel Aviv-University',
      rus: 'Тель-Авив - Университет',
      arb: 'تل أبيب - الجامعة'
    }
  },
  3700: {
    id: '3700',
    labels: {
      heb: 'תל אביב - סבידור מרכז',
      eng: 'Tel Aviv-Savidor Center',
      rus: 'Тель-Авив - Мерказ - Центральная',
      arb: 'تل ابيب – ساڤيدور المركز'
    }
  },
  4100: {id: '4100', labels: {heb: 'בני ברק', eng: 'Bnei Brak', rus: 'Бней-Брак', arb: 'بني براك'}},
  4170: {
    id: '4170',
    labels: {
      heb: 'פתח תקווה  - קריית אריה',
      eng: 'Petah Tikva-Kiryat Arye',
      rus: 'Петах Тиква – Кирьят Арье',
      arb: 'بيتح تكڤا - كريات أريه'
    }
  },
  4250: {
    id: '4250',
    labels: {
      heb: 'פתח תקווה - סגולה',
      eng: 'Petah Tikva-Segula',
      rus: 'Петах-Тиква - Сгула',
      arb: 'بيتح تكڤا - سچوله'
    }
  },
  4600: {
    id: '4600',
    labels: {
      heb: 'תל אביב - השלום',
      eng: 'Tel Aviv-HaShalom',
      rus: 'Тель-Авив - ха-Шалом',
      arb: 'تل أبيب - السلام'
    }
  },
  4640: {
    id: '4640',
    labels: {heb: 'צומת חולון', eng: 'Holon Junction', rus: 'Холон - Развязка Холон', arb: 'مفترق حولون'}
  },
  4660: {
    id: '4660',
    labels: {heb: 'חולון - וולפסון', eng: 'Holon-Wolfson', rus: 'Холон - Вольфсон', arb: 'حولون - ڤولفسون'}
  },
  4680: {
    id: '4680',
    labels: {
      heb: 'בת ים - יוספטל',
      eng: 'Bat Yam-Yoseftal',
      rus: 'Бат Ям - Йосеф Таль',
      arb: 'بات يام - يوسفطال'
    }
  },
  4690: {
    id: '4690',
    labels: {
      heb: 'בת ים - קוממיות',
      eng: 'Bat Yam-Komemiyut',
      rus: 'Бат Ям - Комемуют',
      arb: 'بات يام - كوميميوت'
    }
  },
  4800: {id: '4800', labels: {heb: 'כפר חב"ד', eng: 'Kfar Habad', rus: 'Кфар ХАБАД', arb: 'كفار حباد'}},
  4900: {
    id: '4900',
    labels: {
      heb: 'תל אביב - ההגנה',
      eng: 'Tel Aviv-HaHagana',
      rus: 'Тель-Авив - ха-Хагана ',
      arb: 'تل أبيب - ههچناه'
    }
  },
  5000: {id: '5000', labels: {heb: 'לוד', eng: 'Lod', rus: 'Лод', arb: 'اللد'}},
  5010: {id: '5010', labels: {heb: 'רמלה', eng: 'Ramla', rus: 'Рамле', arb: 'الرملة'}},
  5150: {
    id: '5150',
    labels: {heb: 'לוד גני אביב', eng: 'Lod-Gane Aviv', rus: 'Лод - Ганей Авив', arb: 'اللد - چاني أڤيڤ'}
  },
  5200: {
    id: '5200',
    labels: {heb: 'רחובות', eng: 'Rehovot', rus: 'Реховот- им. А. Хадара', arb: 'رحوڤوت'}
  },
  5300: {
    id: '5300',
    labels: {heb: 'באר יעקב', eng: 'Be\'er Ya\'akov', rus: 'Беер-Яаков', arb: 'بئير يعكوف'}
  },
  5410: {
    id: '5410',
    labels: {heb: 'יבנה מזרח', eng: 'Yavne-East', rus: 'Явне-Восток', arb: 'ياڤنه - شرق'}
  },
  5800: {
    id: '5800',
    labels: {
      heb: 'אשדוד עד הלום (מ\' בר כוכבא)',
      eng: 'Ashdod-Ad Halom (M.Bar Kochva)',
      rus: 'Ашдод-ад-Халом (М. Бар Кохва)',
      arb: 'أشدود - عاد هلوم'
    }
  },
  5900: {id: '5900', labels: {heb: 'אשקלון', eng: 'Ashkelon', rus: 'Ашкелон ', arb: 'أشكلون'}},
  6150: {
    id: '6150',
    labels: {
      heb: 'קרית מלאכי - יואב',
      eng: 'Kiryat Malakhi – Yoav',
      rus: 'Кирьят Малахи-Йоав',
      arb: 'كريات ملاخي – يوآڤ'
    }
  },
  6300: {id: '6300', labels: {heb: 'בית שמש', eng: 'Bet Shemesh', rus: 'Бейт Шемеш', arb: 'بيت شيمش'}},
  6500: {
    id: '6500',
    labels: {
      heb: 'ירושלים - גן החיות התנכי',
      eng: 'Jerusalem-Biblical Zoo',
      rus: 'Иерусалим – зоопарк',
      arb: 'القدس - حديقة الحيوان التوراتية'
    }
  },
  6700: {
    id: '6700',
    labels: {heb: 'ירושלים - מלחה', eng: 'Jerusalem-Malha', rus: 'Иерусалим - Малха', arb: 'القدس - المالحه'}
  },
  6900: {
    id: '6900',
    labels: {heb: 'מזכרת בתיה', eng: 'Mazkeret Batya', rus: 'Мазкерет Батья', arb: 'مزكيرت باتيا'}
  },
  7000: {id: '7000', labels: {heb: 'קריית גת', eng: 'Kiryat Gat', rus: 'Кирьят-Гат ', arb: 'كريات چات'}},
  7300: {
    id: '7300',
    labels: {
      heb: 'באר שבע- צפון/אוניברסיטה',
      eng: 'Be\'er Sheva-North/University',
      rus: 'Беер-Шева Цафон',
      arb: 'بئر السبع - شمال/الجامعة'
    }
  },
  7320: {
    id: '7320',
    labels: {
      heb: 'באר שבע - מרכז',
      eng: 'Be\'er Sheva-Center',
      rus: 'Беер-Шева Мерказ',
      arb: 'بئر السبع - المركز'
    }
  },
  7500: {id: '7500', labels: {heb: 'דימונה', eng: 'Dimona', rus: 'Димона', arb: 'ديمونا'}},
  8550: {
    id: '8550',
    labels: {heb: 'להבים - רהט', eng: 'Lehavim-Rahat', rus: 'Леавим - Рахат', arb: 'لهاڤيم - رهط'}
  },
  8600: {
    id: '8600',
    labels: {
      heb: 'נתב״ג',
      eng: 'Ben Gurion Airport',
      rus: 'Бен-Гурион Аэропорт',
      arb: 'مطار بن چوريون'
    }
  },
  8700: {
    id: '8700',
    labels: {
      heb: 'כפר סבא - נורדאו (א\' קוסטיוק)',
      eng: 'Kfar Sava-Nordau (A.Kostyuk)',
      rus: 'Кфар-Саба – Нордау (А. Костюк)',
      arb: 'كفار سابا - نورداو'
    }
  },
  8800: {
    id: '8800',
    labels: {
      heb: 'ראש העין - צפון',
      eng: 'Rosh Ha\'Ayin-North',
      rus: 'Рош ха-Айн Цафон',
      arb: 'روش هعاين - شمال'
    }
  },
  9000: {
    id: '9000',
    labels: {heb: 'יבנה מערב', eng: 'Yavne-West', rus: 'Явне-Запад', arb: 'ياڤني - غرب'}
  },
  9100: {
    id: '9100',
    labels: {
      heb: 'ראשון לציון - הראשונים',
      eng: 'Rishon LeTsiyon-HaRishonim',
      rus: 'Ришон ле-Цион - Ха-Ришоним ',
      arb: 'ريشون لتسيون - هريشونيم'
    }
  },
  9200: {
    id: '9200',
    labels: {
      heb: 'הוד השרון - סוקולוב',
      eng: 'Hod HaSharon-Sokolov',
      rus: 'Ход Хашарон - Соколов',
      arb: 'هود هشارون - سوكولوڤ'
    }
  },
  9600: {id: '9600', labels: {heb: 'שדרות', eng: 'Sderot', rus: 'Сдерот', arb: 'سديروت'}},
  9650: {id: '9650', labels: {heb: 'נתיבות', eng: 'Netivot', rus: 'Нетивот', arb: 'نتيفوت'}},
  9700: {id: '9700', labels: {heb: 'אופקים', eng: 'Ofakim', rus: 'Офаким', arb: 'أوفاكيم'}},
  9800: {
    id: '9800',
    labels: {
      heb: 'ראשון לציון-משה דיין',
      eng: 'Rishon LeTsiyon-Moshe Dayan',
      rus: 'Ришон-Ле-Цион станция им. Моше Даяна',
      arb: 'ريشون لتسيون -موشي ديان'
    }
  }
};

export const STATIONS: StationsList = stations;

type StationsBaseType = typeof stations;

interface StationsList extends StationsBaseType {
  [id: string]: StationsBaseType[keyof StationsBaseType];
}
